var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('el-button',{staticClass:"getNumber",on:{"click":_vm.getCode}},[_vm._v(" "+_vm._s(_vm.codeMsg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }